import React, { useState, useEffect } from 'react';
import {Instagram, Linkedin} from "lucide-react";

const TeamMemberCard = ({ member = {} }) => {
  const { name = '', image = '/api/placeholder/400/400', funFacts = [], education = '' } = member;
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Close modal on escape key
  useEffect(() => {
    const closeOnEscape = (e) => {
      if (e.key === 'Escape') {
        setIsModalOpen(false);
      }
    };

    if (isModalOpen) {
      document.addEventListener('keydown', closeOnEscape);
    }

    return () => {
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [isModalOpen]);

  // Prevent scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  return (
    <>
      <li 
        className="team-card"
        onClick={() => setIsModalOpen(true)}
        style={{ cursor: 'pointer' }}
      >
        <div className="team-card-inner">
          <div className="team-card-image">
            <img src={image} alt={name} />
          </div>
          
          <div className="team-card-content">
            <h3 className="team-card-title">{name}</h3>
            
            <div className="team-card-section">
              <h4 className="team-card-section-title">Education</h4>
              <p>{education}</p>
            </div>
            
            <div className="team-card-section">
              <h4 className="team-card-section-title">Fun Facts</h4>
              <ul className="team-card-facts">
                {funFacts.map((fact, index) => (
                  <li key={index} className="team-card-fact">{fact}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </li>

      {isModalOpen && (
        <>
          <div 
            className="modal-overlay"
            onClick={() => setIsModalOpen(false)}
          />
          <div className="modal">
            <button 
              className="modal-close"
              onClick={() => setIsModalOpen(false)}
            >
              ×
            </button>
            <div className="modal-content">
              <h2 className="modal-title">{name}</h2>
              <div className="modal-body">
                <div className="modal-profile">
                  <img src={image} alt={name} className="modal-image" />
                  <div>
                    <h3 className="modal-education">{education}</h3>
                  </div>
                </div>
                
                <div className="social-links">
                  {member.socials?.linkedin && (
                    <a
                        href={member.socials.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                    >
                      <Linkedin />
                    </a>
                  )}
                  {member.socials?.instagram && (
                    <a
                      href={member.socials.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                    >
                      <Instagram />
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TeamMemberCard;